#import "@/components/common/CraftAssetFragment.gql"
#import "@/components/common/LinkFragment.gql"

fragment CourseConversionBannerFragment on courseConversionBanner_Entry {
  typeHandle
  heading
  course
  bodyText
  image {
    ...CraftAssetFragment
  }
  boxPositionRight
  cta {
    ...LinkFragment
  }
  agreementCategory {
    ... on preAssessment_Entry {
      title
      agreementBody
      agreementLabel
      disagreementLabel
      confirmButtonLabel
      cancelButtonLabel
    }
  }
  staticPrice: price
  staticCompareAtPrice: compareAtPrice
}
